module.exports = __webpack_public_path__ + "static/clasificacion-717b3395c12eb3b2d59a200f73deda61.png";